import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { BRAND, whatsappLink } from "@/config";

const LINKS = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-2xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-display text-2xl font-extrabold tracking-tight text-white">
            NG
            <span className="text-[#0052ff]">M</span>
          </span>
          <span className="hidden sm:inline text-[10px] tracking-[0.35em] text-[#94a3b8] uppercase">
            Nordglanz
          </span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-[#94a3b8] hover:text-white transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp"
            className="inline-flex items-center gap-2 rounded-full bg-[#0052ff] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#0043cf] transition-colors duration-300"
          >
            <FaWhatsapp className="text-base" />
            Anfragen
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Menü"
        >
          <span className="w-6 h-px bg-white" />
          <span className="w-6 h-px bg-white" />
          <span className="w-4 h-px bg-white self-end" />
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-black/90 backdrop-blur-2xl border-t border-white/10 px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[#94a3b8] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#0052ff] px-5 py-3 text-sm font-medium text-white w-fit"
          >
            <FaWhatsapp /> {BRAND.name} anfragen
          </a>
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
